export const storePersist = {
	set: (key: any, state: any) => {
		window.localStorage.setItem(key, JSON.stringify(state));
	},
	get: (key: any) => {
		const result = window.localStorage.getItem(key);
		return result ? JSON.parse(result) : null
	},
	remove: (key: any) => {
		window.localStorage.removeItem(key);
	},
	getAll: () => {
		return window.localStorage;
	},
	clear: () => {
		window.localStorage.clear();
	},
};

export default storePersist;
